import { render, staticRenderFns } from "./HeartCenter.vue?vue&type=template&id=70f6248e&scoped=true"
import script from "./HeartCenter.vue?vue&type=script&lang=js"
export * from "./HeartCenter.vue?vue&type=script&lang=js"
import style0 from "./HeartCenter.vue?vue&type=style&index=0&id=70f6248e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f6248e",
  null
  
)

export default component.exports